const mrs = [
  [
    [
      "No symptoms at all (0)", 
      "No significant disability despite symptoms; able to carry out all usual duties and activities (1)",
      "Slight disability; unable to carry out all previous activities, but able to look after own affairs without assistance (2)",
      "Moderate disability; requiring some help (e.g. with shopping/managing affairs) but able to walk without assistance (3)",
      "Moderately severe disability; unable to walk without assistance and unable to attend to own bodily needs without assistance (4)",
      "Slight disability; unable to carry out all previous activities, but able to look after own affairs without assistance (5)",
      "Severe disability; bedridden, incontinent and requiring constant nursing care and attention (6)"
    ], "mrs", 0, 6
  ]
];

export const mrsItems = [
  ["Modified Rankin Scale", mrs]
];